import MuiTableContainer, { TableContainerProps as MuiTableContainerProps } from '@material-ui/core/TableContainer';

export type DSTableContainerProps = MuiTableContainerProps;

export const DSTableContainer = MuiTableContainer;
